<template>
    <v-container fluid>
        <v-row>
            <sarala-table
                :model="model"
                :createRoute="{ name: 'settings.create' }"
                :resourceName="$tc('resources.settings.name', 1)"
                ref="table"
            >
                <template #action="{ item }">
                    <edit-btn
                        :to="{
                            name: 'settings.edit',
                            params: { id: item.id },
                        }"
                    />
                    <delete-btn @click="deleteItem(item)" />
                </template>
            </sarala-table>
        </v-row>
        <confirm-delete ref="confirmDelete" />
    </v-container>
</template>

<script>
import Setting from '@/models/Setting'
import SaralaTable from '@/shared/components/SaralaTable'

export default {
    components: {
        SaralaTable,
    },

    computed: {
        model() {
            return new Setting()
        },
    },

    methods: {
        async deleteItem(item) {
            let confirmed = await this.$refs.confirmDelete.confirm(item.name)
            if (!confirmed) return

            await item.delete()

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.settings.name'),
                }),
            )
        },
    },
}
</script>

<style></style>
